import { render, staticRenderFns } from "./RealPayingTargetTable.vue?vue&type=template&id=36bb3a4a&scoped=true"
import script from "./RealPayingTargetTable.vue?vue&type=script&lang=js"
export * from "./RealPayingTargetTable.vue?vue&type=script&lang=js"
import style0 from "./RealPayingTargetTable.vue?vue&type=style&index=0&id=36bb3a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bb3a4a",
  null
  
)

export default component.exports